<form [formGroup]="directoryAddRequestService.addRequestForm" *ngIf="directoryAddRequestService.addRequestForm && showForm">
  <app-directory-fields-request
    [config]="widgetConfig"
    [lang]="currentLang"
    [community]="selectedCommunity"></app-directory-fields-request>
</form>
  